import { Link } from "react-router-dom";
import Header from "../components/Header/Header";
import PageBanner from "../components/about/PageBanner";
import Counter from "../components/Counter";
import Footer from "../components/Footer/Footer";
import { Fade } from "react-awesome-reveal";
import AboutCube from "../components/about/AboutCube";
import ImageMasonry from "../components/masonary/MasonaryAbout";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchTranslations } from "../actions/languageActions";
import NewHeader from "../components/Header/NewHeader";
import Loading from "../components/loading/Loading";
import FormModal from "../elements/FormModal";
import { Helmet } from "react-helmet-async";
import FormModalOne from "../elements/FormModalOne";

const FirstAidNew = () => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const translations = useSelector((state) => state.language.translations[selectedLanguage]);
  
  // --- STATE FOR FIRST AID ---
  const [firstAidDates, setFirstAidDates] = useState([
    { id: 1, date: "Sat 31 Oct 2026", time: "09:00 - 13:00", venue: "Adelaide", price: "$95", fillingFast: true },
    { id: 2, date: "Tue 3 Nov 2026", time: "09:00 - 13:00", venue: "Adelaide", price: "$95", fillingFast: false },
    { id: 3, date: "Wed 4 Nov 2026", time: "09:00 - 13:00", venue: "Adelaide", price: "$95", fillingFast: false },
  ]);
  const [searchDateFA, setSearchDateFA] = useState("");
  const [showSearchResultsFA, setShowSearchResultsFA] = useState(false);

  // --- STATE FOR CPR ---
  const [cprDates, setCprDates] = useState([
    { id: 1, date: "Sat 31 Oct 2026", time: "09:00 - 12:00", venue: "Adelaide", price: "$45", fillingFast: true },
    { id: 2, date: "Tue 3 Nov 2026", time: "09:00 - 12:00", venue: "Adelaide", price: "$45", fillingFast: false },
  ]);
  const [searchDateCPR, setSearchDateCPR] = useState("");
  const [showSearchResultsCPR, setShowSearchResultsCPR] = useState(false);

  // --- HANDLERS ---
  const loadMoreFirstAid = () => {
    const lastId = firstAidDates[firstAidDates.length - 1].id;
    const newRows = [
      { id: lastId + 1, date: "Thu 5 Nov 2026", time: "09:00 - 13:00", venue: "Adelaide", price: "$95", fillingFast: false },
      { id: lastId + 2, date: "Fri 6 Nov 2026", time: "09:00 - 13:00", venue: "Adelaide", price: "$95", fillingFast: true },
    ];
    setFirstAidDates((prev) => [...prev, ...newRows]);
  };

  const loadMoreCpr = () => {
    const lastId = cprDates[cprDates.length - 1].id;
    const newRows = [
      { id: lastId + 1, date: "Thu 5 Nov 2026", time: "09:00 - 12:00", venue: "Adelaide", price: "$45", fillingFast: false },
      { id: lastId + 2, date: "Fri 6 Nov 2026", time: "09:00 - 12:00", venue: "Adelaide", price: "$45", fillingFast: false },
    ];
    setCprDates((prev) => [...prev, ...newRows]);
  };

  const handleDateSearchFA = (e) => {
    setSearchDateFA(e.target.value);
    setShowSearchResultsFA(!!e.target.value);
  };

  const handleDateSearchCPR = (e) => {
    setSearchDateCPR(e.target.value);
    setShowSearchResultsCPR(!!e.target.value);
  };

  useEffect(() => {
    dispatch(fetchTranslations(selectedLanguage));
  }, [dispatch, selectedLanguage]);
  
  if (!translations) {
    return (
      <div>
        <Loading />
      </div>
    ); 
  }
  
  return (
    <>
      <Helmet>
        <title>HLTAID011 First Aid Course - Signet Institute of Australia</title>
        <meta name='description' content='First Aid Course HLTAID011 at Signet Institute, a 1-day course with practical training, expert instructors and nationally recognised skills. Enrol today.' data-rh="true" />
      </Helmet>
      <NewHeader />

      <div className="about-sec-">
        {/* Hero Section */}
        <section className="pt-150 nanhe">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 pt-60">
                <h1 className="title-banner">
                  First Aid Course
                </h1>
                <p>Embrace the opportunity to grow, develop, and achieve your goals with Signet Institute of Australia. Take the first step towards a brighter future by exploring our Provide First Aid below and embark on a transformative educational journey like no other.</p>
                <a href="#booknow" className="theme-btn my-15">
                  Book Now 
                </a>
              </div>
              <div className="col-md-6">
                <div className="banner-ab-image text-center">
                  <img src="/images/first_aid.jpg" alt="First Aid Training" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* COURSE DETAILS & SCHEDULE SECTION */}
        <section className="course-details-section pt-60 pb-65">
          <div className="container">
            <div className="row">
              {/* Left Column - Course Info & Schedule */}
              <div className="col-lg-8 mb-4 mb-lg-0">
                <div className="course-main-content">
                  
                  {/* === COURSE 1: FIRST AID === */}
                  <div className="course-block mb-5">
                    <h2 className="course-title">HLTAID011 - Provide First Aid in Adelaide</h2>
                    <div className="course-meta-top">
                      <span className="duration">4 hours</span>
                      <span className="badge-cpr">Includes CPR</span>
                    </div>
                    <p className="course-intro">The complete workplace first aid certificate. Includes CPR — most workplaces ask for this one.</p>
                    
                    <div className="schedule-table-wrapper">
                      <table className="schedule-table">
                        <thead>
                          <tr>
                            <th>DATE</th>
                            <th>TIME</th>
                            <th>VENUE</th>
                            <th>PRICE</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {firstAidDates.map((row) => (
                            <tr key={`fa-${row.id}`}>
                              <td data-label="Date">{row.date}</td>
                              <td data-label="Time">{row.time}</td>
                              <td data-label="Venue">{row.venue}</td>
                              <td data-label="Price"><strong>{row.price}</strong></td>
                              <td data-label="Action">
                                <div className="action-cell">
                                  {row.fillingFast && <span className="filling-fast-badge">Filling fast</span>}
                                  <button className="enrol-btn">Enrol now <i className="fas fa-arrow-right"></i></button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="load-more-wrapper">
                        <button className="load-more-btn" onClick={loadMoreFirstAid}>
                          Load more dates
                        </button>
                      </div>
                    </div>

                    {/* FIRST AID DATE SEARCH */}
                    <div className="date-search-container mt-4">
                      <div className="date-search-box">
                        <h5 className="date-search-title">Need a later date?</h5>
                        <p className="date-search-subtitle">Pick a date further ahead to enrol.</p>
                        <input type="date" className="date-input" value={searchDateFA} onChange={handleDateSearchFA} />
                        {showSearchResultsFA && (
                          <div className="search-results-box mt-3">
                            <div className="search-result-row">
                              <span className="result-date">Tue, 3 Nov 2026</span>
                              <span className="result-dot">·</span>
                              <span className="result-time">09:00 - 13:00</span>
                              <span className="result-dot">·</span>
                              <span className="result-price">$95</span>
                              <button className="enrol-btn ml-auto">Enrol now <i className="fas fa-arrow-right"></i></button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* === COURSE 2: CPR === */}
                  <div className="course-block pt-20">
                    <h3 className="course-title" style={{ fontSize: '24px' }}>HLTAID009 - Provide Cardiopulmonary Resuscitation</h3>
                    <div className="course-meta-top">
                      <span className="duration">3 hours</span>
                    </div>
                    <p className="course-intro">This course provides the skills and knowledge required to perform CPR in line with the Australian Resuscitation Council (ARC) guidelines.</p>

                    <div className="schedule-table-wrapper">
                      <table className="schedule-table">
                        <thead>
                          <tr>
                            <th>DATE</th>
                            <th>TIME</th>
                            <th>VENUE</th>
                            <th>PRICE</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {cprDates.map((row) => (
                            <tr key={`cpr-${row.id}`}>
                              <td data-label="Date">{row.date}</td>
                              <td data-label="Time">{row.time}</td>
                              <td data-label="Venue">{row.venue}</td>
                              <td data-label="Price"><strong>{row.price}</strong></td>
                              <td data-label="Action">
                                <div className="action-cell">
                                  {row.fillingFast && <span className="filling-fast-badge">Filling fast</span>}
                                  <button className="enrol-btn">Enrol now <i className="fas fa-arrow-right"></i></button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="load-more-wrapper">
                        <button className="load-more-btn" onClick={loadMoreCpr}>
                          Load more dates
                        </button>
                      </div>
                    </div>

                    {/* CPR DATE SEARCH */}
                    <div className="date-search-container mt-4">
                      <div className="date-search-box">
                        <h5 className="date-search-title">Need a later date?</h5>
                        <p className="date-search-subtitle">Pick a date further ahead to enrol.</p>
                        <input type="date" className="date-input" value={searchDateCPR} onChange={handleDateSearchCPR} />
                        {showSearchResultsCPR && (
                          <div className="search-results-box mt-3">
                            <div className="search-result-row">
                              <span className="result-date">Tue, 3 Nov 2026</span>
                              <span className="result-dot">·</span>
                              <span className="result-time">09:00 - 12:00</span>
                              <span className="result-dot">·</span>
                              <span className="result-price">$45</span>
                              <button className="enrol-btn ml-auto">Enrol now <i className="fas fa-arrow-right"></i></button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              {/* Right Column - Sidebar */}
              <div className="col-lg-4">
                <div className="course-sidebar">
                  <div className="widget widget-course-details text-center">
                    <img src="/img/about/course-details.png" alt="Nationally Recognised Training" className="img-fluid" />
                    <ul className="course-details-list mt-20 mb-25">
                      <li><i className="far fa-file-alt" /> <span>Course Code:</span> <b>HLTAID011</b></li>
                      <li><i className="far fa-clock" /> <span>CRICOS Code:</span> <b>NA</b></li>
                      <li><i className="far fa-play-circle" /> <span>Duration:</span> <b>1 days</b></li>
                      <li><i className="far fa-clipboard" /> <span>Faculty:</span> <b>Health Course</b></li>
                      <li><i className="far fa-clipboard" /> <span>Course Fee:</span> <b>$190</b></li>
                    </ul>
                    <div className="sidebar-buttons">
                      <FormModalOne />
                      <a href="#booknow" className="theme-btn mt-10 w-100">
                        Book Now <i className="fas fa-arrow-right" />
                      </a>
                    </div>
                  </div>
                  
                  <div className="widget widget-menu mt-4">
                    <h5 className="widget-title"><a href="https://signet.edu.au/automotive-courses">Automotive Courses (3)</a></h5>
                    <h5 className="widget-title"><a href="https://signet.edu.au/business-courses">Business Courses (3)</a></h5>
                    <h5 className="widget-title"><a href="https://signet.edu.au/construction-courses">Construction Courses (5)</a></h5>
                    <h5 className="widget-title"><a href="https://signet.edu.au/community-courses">Community Courses (5)</a></h5>
                    <h5 className="widget-title"><a href="https://signet.edu.au/healthcare-courses">Healthcare Courses (3)</a></h5>
                    <h5 className="widget-title"><a href="https://signet.edu.au/general-english">General English (1)</a></h5>
                    <h5 className="widget-title"><a href="https://signet.edu.au/manufacturing-and-engineering">Manufacturing and Engineering (1)</a></h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* GUIDES SECTION */}
        <section className="guides-section pt-40 pb-60">
          <div className="container">
            <div className="guides-header">
              <h2 className="section-main-title">First Aid & CPR guides</h2>
              <a href="#" className="view-all-link">All guides <i className="fas fa-arrow-right"></i></a>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="guide-card">
                  <h5>How often do you need to renew your first aid certificate in Australia?</h5>
                  <p>In Australia, refresh your CPR every 12 months and your first aid certificate every 3 years. Here's what that means and how to renew.</p>
                  <a href="#" className="read-guide-link">Read guide <i className="fas fa-arrow-right"></i></a>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="guide-card">
                  <h5>CPR vs First Aid vs Childcare First Aid: which course do you need?</h5>
                  <p>A plain-English guide to choosing between HLTAID009 CPR, HLTAID011 Provide First Aid and HLTAID012 Childcare First Aid.</p>
                  <a href="#" className="read-guide-link">Read guide <i className="fas fa-arrow-right"></i></a>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="guide-card">
                  <h5>DRSABCD: the first aid action plan explained</h5>
                  <p>DRSABCD is the step-by-step first aid action plan — Danger, Response, Send for help, Airway, Breathing, CPR, Defibrillation.</p>
                  <a href="#" className="read-guide-link">Read guide <i className="fas fa-arrow-right"></i></a>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="guide-card">
                  <h5>Is your first aid certificate nationally recognised? (USI explained)</h5>
                  <p>What 'nationally recognised' means, why your certificate works Australia-wide and the free USI you need to be issued it.</p>
                  <a href="#" className="read-guide-link">Read guide <i className="fas fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ SECTION */}
        <section className="faq-section pt-60 pb-80">
          <div className="container">
            <h2 className="section-main-title text-center">First Aid & CPR in Adelaide — FAQ</h2>
            <div className="faq-accordion-wrapper">
              <details className="faq-item">
                <summary>Where is First Aid & CPR training held in Adelaide?</summary>
                <div className="faq-content">Our Adelaide campus is located at Level 5 & 9, 341-345 Queen Street, Adelaide VIC 3000.</div>
              </details>
              <details className="faq-item">
                <summary>How much is First Aid & CPR in Adelaide?</summary>
                <div className="faq-content">Pricing details go here.</div>
              </details>
              <details className="faq-item">
                <summary>How do I get to the Adelaide centre?</summary>
                <div className="faq-content">Transport and parking information goes here.</div>
              </details>
              <details className="faq-item">
                <summary>Is the certificate nationally recognised?</summary>
                <div className="faq-content">Yes, it is nationally recognised under the Australian Qualifications Framework.</div>
              </details>
              <details className="faq-item">
                <summary>Which first aid course do I need?</summary>
                <div className="faq-content">Course selection guidance goes here.</div>
              </details>
            </div>
          </div>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default FirstAidNew;